import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoCity from '../../../referential/dto/DtoCity'
import DtoPoint from '../../dto/DtoPoint'
import { find, orderBy } from 'lodash'
import DtoNetwork from '../../dto/DtoNetwork'
import { getDate } from '../../../utils/DateUtil'
import DtoWatershed from '../../../referential/dto/DtoWatershed'
import { formatNumber } from '../../../utils/NumberUtils'
import SitesAction from '../../../sites/actions/SitesAction'
import AppStore from '../../../store/AppStore'
import DtoStation from '../../../sites/dto/DtoStation'
import Checkbox from '@material-ui/core/Checkbox'

class PointDescriptionPanel extends Component {
	constructor(props) {
		super(props)
	}

	putInformations = (title, value) => {
		if (value) {
			return (
				<div className='row no-margin'>
					<div className='col s2 left-align'><b>{ title }</b></div>
					<div className='col s10 left-align'>{ value }</div>
				</div>
			)
		}
		return null
	}

	getNetworks = () => {
		if (this.props.pointNetworks && this.props.pointNetworks.length) {
			const result = orderBy(this.props.pointNetworks, ['beginDate'], ['desc']).map((o) => {
				const dateBegin = o.beginDate ? getDate(o.beginDate) : ''
				const endDate = o.endDate ? getDate(o.endDate) : ''
				return (
					<div className='row no-margin'>
						<div className='col s2 no-padding'>
							{ o.code }
						</div>
						<div className='col s6 no-padding truncate'>
							{ o.name }
						</div>
						<div className='col s2 no-padding center-align'>
							{ dateBegin }
						</div>
						<div className='col s2 no-padding center-align'>
							{ endDate }
						</div>
					</div>
				)
			})
			return this.putInformations(i18n.point.network, result)
		}
		return null
	}
	getWaterShed = () => {
		if (this.props.watersheds && this.props.watersheds.length) {
			if (this.props.point.watershedId) {
				const watershed = find(this.props.watersheds, (o) => {
					return o.id == this.props.point.watershedId
				})
				if (watershed) {
					return this.putInformations(i18n.point.watershed, watershed.name + ' [' + watershed.code + ']')
				}
				return null
			}
			return null
		}
		return null
	}
	getCoordinates = () => {
		if (this.props.point.xCoordinate && this.props.point.xCoordinate) {
			const coordinate = i18n.point.longitude + ' : ' + formatNumber(this.props.point.xCoordinate) + ' ' + i18n.point.latitude + ' : ' + formatNumber(this.props.point.yCoordinate)
			const finalTotal = (() => {
				if (this.props.point.altitude) {
					return coordinate + ' ' + i18n.point.altitude + ' : ' + this.props.point.altitude
				}
				return coordinate
			})()
			return this.putInformations(i18n.point.coordinate, finalTotal)
		}
		return null
	}

	updateCheck = () => {
		const station = find(this.props.stations, (o) => {
			return o.id == this.props.point.id && o.typeId == this.props.point.typeId
		})
		AppStore.dispatch(SitesAction.toggleSelectedStations(station))
	}

	getCheckStation = () => {
		if (this.props.selectedStations.length) {
			const result = find(this.props.selectedStations, o => o.id === this.props.point.id)
			return !!result
		}
		return false
	}

	getCheck = () => {
		if (this.props.selectedStations.length) {
			return (
				<div className='col s1 no-padding'>
					<div className='row no-margin'>
						<div className='col s2 no-padding left'>
							<Checkbox
								checked={ this.getCheckStation() }
								onCheck={ () => this.updateCheck() }
							/>
						</div>
					</div>
				</div>
			)
		}
		return null
	}

	getData = () => {
		const city = (() => {
			if (this.props.point.cityId) {
				const result = find(this.props.cities, (o) => {
					return o.id == this.props.point.cityId
				})
				if (result) {
					return result.postalCode + ' - ' + result.name + ' [' + result.code + ']'
				}
				return null
			}
			return null
		})()
		const check = this.getCheck()
		return (
			<div className='row no-margin valign-wrapper'>
				{ check }
				<div className={ `col s${ check ? '11' : '12' }` }>
					<div className='row no-margin'>
						<div className='col s12'>
							{ this.putInformations(i18n.point.denomination, this.props.point.name) }
							{ this.putInformations(i18n.point.code, this.props.point.code) }
							{ this.putInformations(i18n.point.localization, this.props.point.localisation) }
							{ this.putInformations(i18n.point.city, city) }
							{ this.getCoordinates() }
							{ this.getNetworks() }
							{ this.getWaterShed() }
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<div className={ 'row card' } id={ this.props.id }>
				<div className='card-content'>
					{ this.getData() }
				</div>
			</div>
		)
	}

	componentDidUpdate() {
		this.props.setHeight(document.getElementById(this.props.id).clientHeight)
	}
}

PointDescriptionPanel.propTypes = {
	id: PropTypes.string.isRequired,
	point: PropTypes.objectOf(DtoPoint),
	cities: PropTypes.arrayOf(PropTypes.objectOf(DtoCity)),
	pointNetworks: PropTypes.arrayOf(PropTypes.objectOf(DtoNetwork)),
	watersheds: PropTypes.arrayOf(PropTypes.objectOf(DtoWatershed)),
	stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	setHeight: PropTypes.func
}

const mapStateToProps = store => {
	return {
		point: store.PointReducer.point,
		cities: store.ReferentialReducer.cities,
		watersheds: store.ReferentialReducer.watersheds,
		pointNetworks: store.PointReducer.pointNetworks,
		stations: store.SitesReducer.stations,
		selectedStations: store.SitesReducer.selectedStations
	}
}

export default connect(mapStateToProps)(PointDescriptionPanel)



// WEBPACK FOOTER //
// ./src/point/components/description/PointDescriptionPanel.js